import React from 'react'
import toast from 'react-hot-toast';
import { api } from '../../../../../../api/report';
import { downloadpptx } from './dowloadpptx.utils';
import { useNavigate } from 'react-router';

const useDownloadReport = ({data, pages, pageStructure, reportTitle} : any) => {

    const navigate = useNavigate();
    const enrichedPages = pages.map((page: any) => {
        const pageContent = pageStructure.filter(
          (element: any) => element.activePageId === page.id
        );
        return {
          ...page,
          pageContent,
        };
      });
    
      const handleSubmit = async (download: boolean) => {
        if (!data) {
          toast.error("No data available");
          return;
        }
    
        const payload: any= {
          name: reportTitle as string || data?.name,
          description: '',
          type: 'pptx',
          size: 'A4',
          orientation: 'landscape',
          width: null,
          height: null,
          pixels: null,
          status: "draft",
          pages: enrichedPages.map((page: any, index: number) => ({
            sort: index + 1,
            pageId: page.id,
            page: JSON.stringify({
              elements: page.pageContent,
              backgroundColor: pages?.find((p: any) => p.id === page.id)
                ?.backgroundColor,
            }),
          })),
        };
    
        console.log(payload?.pages, "payload");
    
        try {
          toast.loading("Loading...");
          const response = await api.updateReport({
            orgId: data?.orgId,
            reportId: data?.id,
            payload,
          });
          toast.remove();
          if(!download) toast.success(response.message);
          if(download){
            downloadpptx({
              data: { name: reportTitle} , enrichedPages, pages
             });
          }
          setTimeout( () => navigate("/admin/report") , 1000 )
          // sessionStorage.removeItem("elements");
          // sessionStorage.removeItem("backgroundImage");
          // sessionStorage.removeItem("reportData");
          // sessionStorage.removeItem("reportElements");
          // sessionStorage.removeItem("brandLogo");
          // sessionStorage.removeItem("brandData");
        } catch (error) {
          toast.remove();
          toast.error(`Error ${error}`);
        }
      };
         
  return {handleSubmit}
}

export default useDownloadReport